import { render } from "./VehicleTable.vue?vue&type=template&id=4efe0ad6&scoped=true"
import script from "./VehicleTable.vue?vue&type=script&lang=js"
export * from "./VehicleTable.vue?vue&type=script&lang=js"

import "./VehicleTable.vue?vue&type=style&index=0&id=4efe0ad6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4efe0ad6"]])

export default __exports__